import { IconButton, type SvgIconProps, styled } from "~/common/mui";
import { ToggleCommentIcon } from "~/common/components/icon/ToggleCommentIcon";

interface CommentButtonProps {
  className?: string;
  onClick: () => void;
  open: boolean;
  fontSize?: SvgIconProps["fontSize"];
}

const StyledIcon = styled(ToggleCommentIcon)(({ theme }) => ({
  fontSize: "24px !important",
  [theme.breakpoints.up("desktop-s")]: {
    fontSize: "16px",
  },
}));

export const CommentButton = ({ className, onClick, open, fontSize }: CommentButtonProps) => (
  <IconButton onClick={onClick} data-test-id={"btn-toggle-comment"} color={"primary"} className={className}>
    <StyledIcon fontSize={fontSize} open={open} />
  </IconButton>
);
